module.exports = __webpack_public_path__ + "img/about_obj.d2688893.svg";